var baseDir = '/'
const nav = {
	// collegeHome: {
	// 	stitle: '学校首页',
	// 	to: 'https://www.zjiet.edu.cn/',
	// 	target: '_blank'
	// },
	index: {
		stitle: '首页',
		to: baseDir,
		class: 'index'
	},
	one: {
		stitle: '学院简介',
		to: baseDir + 'news/one/105',
		class: 'jianjie'
	},
	news: {
		stitle: '新闻动态',
		to: baseDir + 'news/10',
		class: 'news',
		hasSons: true,
		root: 1
	},
	dz: {
		stitle: '党建思政',
		to: baseDir + 'news/99',
		class: 'dz',
		// hasSons: true,
		// root: 91
	},
	edu: {
		stitle: '高等学历继续教育',
		to:  baseDir + 'edu/enroll/74',
		class: 'edu',
		hasSons: true,
		root: 2
	},
	train: {
		stitle: '非学历教育',
		to: baseDir + 'train/news/69',
		class: 'train',
		hasSons: true,
		root: 3
	},
	skill: {
		stitle: '考证',
		to: baseDir + 'news/93',
		class: 'skill',
		hasSons: true,
		root: 92
	},
	download: {
		stitle: '下载专区',
		to: baseDir + 'news/28',
		class: 'download'
	},
	relative: {
		stitle: '联系我们',
		to: baseDir + 'news/relative/33',
		class: 'relative'
	}
}
const menu = {
	1: {  //新闻动态
		10: '推荐新闻',
		11: '学院新闻',
		12: '通知公告'
	},
	91: { //党建思政 
		// 99: '文件精神',  
		// 100: '党员活动'
		99: '党建思政',  
	},
	2: {  //高等学历继续教育
		18: { //专科函授
			' 74': '招生专栏',
			' 73': '专业介绍',
			// 74: { //招生专栏
			// 	77: '招生信息',
			// 	78: '通知公告',
			// 	79: '政策新闻',
			// },
			' 75': '校外教学点信息',
			//76: '下载'
		},
		19: { //专升本函授
			80: '招生信息',
			81: '通知公告',
		},
		20: { //远程教育
			82: '通知公告',
		}
	},
	3: {  //非学历教育
		' 67': { 
			117: '乡村CEO专题',
			70: '培训资讯',
			69: '通知公告',
		},
		' 97': { 
			' 101': '通知公告',
			' 102': '政策新闻',
		},
		' 98': '社会服务平台',
		
	},
	// 3: {  // 非学历教育
	//  	// 21: '轮播图',   
	//  	72: '下载专区',   
	//  	71: '鉴定资讯',   
	//  	70: '培训资讯',   
	//  	69: '通知公告',   
	//  	68: '职业技能鉴定',   
	//  	67: '社会培训',
	// 	89: '图片新闻'
	// },
	// 92: { //职业技能等级认定 
	// 	' 93': '茶艺师',  
	// 	' 94': '农产品食品检验员',  
	// 	' 95': '汽车维修工', 
	// 	' 106': '供销行业职业技能等级评价', 
	// 	' 96': '信息公示'
	// },
	92: {  //考证
		106: '供销行业职业技能等级评价',
		109: { //浙江省职业技能等级认定
			93: '茶艺师', 
			94: '农产品食品检验员',  
			95: '汽车维修工', 
			110: '营养师', 
			111: '物流服务师', 
			116: '风险管理师', 
			96: '农业经理人',  
			112: '计算机程序设计员', 
			113: '插花花艺师', 
			114: '人工智能训练师', 
			115: '评茶师', 
		}
		
	},
	5: { //下载专区  
 		 28: '文件下载'
	},
	6: { //联系我们  
	 	33: '联系我们'
	},
	104: { //学院简介
		105: '学院简介'
   	},

}
	 //,
	// 50: {
	// 	nm: '首页',
	// 	level: 1,
		
	// },  
	// 56: '首页轮播图',   
	// 57: '友情链接',   
	// 58: '浮动弹窗', 
  
	// Collapse
	// 1: '新闻动态',  
	// 10: '推荐新闻',   
	// 11: '学院新闻 ',  
	// 12: '通知公告',   
	// Collapse
	// 2: '高等学历继续教育',  
	// Collapse
	// 18: '专科函授',  
	// 73: '专业介绍',   
	// Collapse
	// 74: '招生专栏',   
	// 77: '招生信息',   
	// 78: '通知公告',   
	// 79: '新闻',   
	// 75: '校外教学点信息',   
	// 76: '下载',   
	// Collapse
	// 19: '专升本函授',   
	// 80: '招生信息',   
	// 81: '通知公告',   
	// Collapse
	// 20: '远程教育',   
	// 82: '通知公告',   
	// Collapse
	// 3: '非学历教育',  
	// 21: '轮播图',   
	// 72: '下载专区',   
	// 71: '鉴定资讯',   
	// 70: '培训资讯',   
	// 69: '通知公告',   
	// 68: '职业技能鉴定',   
	// 67: '社会培训',   
	// Collapse
	// 5: '下载专区',  
	// 28: '文件下载',   
	// Collapse
	// 6: '联系我们',  
	// 33: '联系我们',

const newsType = {
	1: {
		stitle: '新闻动态',
		root: 1,
		parents: [],
		parent: 1,
		to: baseDir + 'news/10',
		icon: 'icon-xinwen',
		children: [10, 11, 12]
	},
	10: {
		stitle: '推荐新闻',
		root: 1,
		parents: [1],
		parent: 1,
		to: baseDir + 'news/10',
	},
	11: {
		stitle: '学院新闻',
		root: 1,
		parents: [1],
		parent: 1,
		to: baseDir + 'news/11',
	},
	12: {
		stitle: '通知公告',
		root: 1,
		parents: [1],
		parent: 1,
		to: baseDir + 'news/12',
	},

	2: {
		stitle: '高等学历继续教育',
		root: 2,
		parents: [],
		parent: '',
		to: baseDir + 'edu/enroll/74',
		icon: 'icon-xueli',
		children: [18, 19, 20]
	},
	18: {
		stitle: '专科函授',
		root: 2,
		parents: [2],
		parent: 2,
		to: baseDir + 'edu/enroll/74',
	},
	74: {
		stitle: '招生专栏',
		root: 2,
		parents: [2, 18],
		parent: 18,
		to: baseDir + 'edu/enroll/74',
		children: [77, 78, 79],
		// 77: '招生信息',   
		// 78: '通知公告',   
		// 79: '新闻',   
		// 75: '校外教学点信息',   
		// 76: '下载', 
	},
	73: {
		stitle: '专业介绍',
		root: 2,
		parents: [2, 18],
		parent: 18,
		to: baseDir + 'edu/dis/73',
	},
	77: {
		stitle: '招生信息',
		root: 2,
		parents: [2, 18, 74],
		parent: 74,
		to: baseDir + 'edu/enroll/77',
	},
	78: {
		stitle: '通知公告',
		root: 2,
		parents: [2, 18, 74],
		parent: 74,
		to: baseDir + 'edu/enroll/78',
	},
	79: {
		stitle: '政策新闻',
		root: 2,
		parents: [2, 18, 74],
		parent: 74,
		to: baseDir + 'edu/enroll/79',
	},
	75: {
		stitle: '校外教学点信息',
		root: 2,
		parents: [2, 18],
		parent: 18,
		to: baseDir + 'edu/teach-point/75',
	},
	// 76: {
	// 	stitle: '下载',
	// 	root: 2,
	// 	parents: [2, 18],
	// 	parent: 18,
	// 	//to: baseDir + 'edu/download/76',
	// 	to: baseDir + 'edu/news/76',
	// },

	19: {
		stitle: '专升本函授',
		root: 2,
		parents: [2],
		parent: 2,
		to: baseDir + 'edu/news/80',
	},
	80: {
		stitle: '招生信息',
		root: 2,
		parents: [2, 19],
		parent: 19,
		to: baseDir + 'edu/news/80',
	},
	81: {
		stitle: '通知公告',
		root: 2,
		parents: [2, 19],
		parent: 19,
		to: baseDir + 'edu/news/81',
	},
	20: {
		stitle: '远程教育',
		root: 2,
		parents: [2],
		parent: 2,
		to: baseDir + 'edu/news/82',
	},
	82: {
		stitle: '通知公告',
		root: 2,
		parents: [2, 20],
		parent: 20,
		to: baseDir + 'edu/news/82',
	},
	3: {
		stitle: '非学历教育',
		root: 3,
		parents: [],
		parent: 3,
		to: baseDir + 'train/news/69',
		icon: 'icon-jiaoyu',
		children: [67, 97, 98]
	},
	92: {
		stitle: '考证',
		root: 92,
		parents: [],
		parent: 92,
		to: baseDir + 'news/69',
		icon: 'icon-zhiyejinengjianding',
		children: [106, 109]
	},
	97: {
		stitle: '社区教育',
		root: 3,
		parents: [3],
		parent: 3,
		to: baseDir + 'train/news/101',
	},
	101: {
		stitle: '通知公告',
		root: 3,
		parents: [3,97],
		parent: 97,
		to: baseDir + 'train/news/101',
	},
	102: {
		stitle: '政策新闻',
		root: 3,
		parents: [3,97],
		parent: 97,
		to: baseDir + 'train/news/102',
	},

	67: {
		stitle: '社会培训',
		root: 3,
		parents: [3],
		parent: 3,
		to: baseDir + 'train/news/69',
	},
	117: {
		stitle: '乡村CEO专题',
		root: 3,
		parents: [3,67],
		parent: 67,
		to: baseDir + 'train/news/117',
	},
	70: {
		stitle: '培训资讯',
		root: 3,
		parents: [3,67],
		parent: 67,
		to: baseDir + 'train/news/70',
	},
	69: {
		stitle: '通知公告',
		root: 3,
		parents: [3,67],
		parent: 67,
		to: baseDir + 'train/news/69',
	},
	98: {
		stitle: '社会服务平台',
		root: 3,
		parents: [3],
		parent: 3,
		link: 'https://zjiet.cjnep.net/sims/',
		// link: 'https://jxjypx.zjiet.edu.cn/',gjx
	},
	// 67: {
	// 	stitle: '社会培训',
	// 	root: 3,
	// 	parents: [3],
	// 	parent: 3,
	// 	to: baseDir + 'train/news/67',
	// },
	// 68: {
	// 	stitle: '职业技能鉴定',
	// 	root: 3,
	// 	parents: [3],
	// 	parent: 3,
	// 	to: baseDir + 'train/news/68',
	// },
	// 69: {
	// 	stitle: '通知公告',
	// 	root: 3,
	// 	parents: [3],
	// 	parent: 3,
	// 	to: baseDir + 'train/news/69',
	// },
	// 69: {
	// 	stitle: '通知公告',
	// 	root: 3,
	// 	parents: [3],
	// 	parent: 3,
	// 	to: baseDir + 'train/news/69',
	// },
	// 70: {
	// 	stitle: '培训资讯',
	// 	root: 3,
	// 	parents: [3],
	// 	parent: 3,
	// 	to: baseDir + 'train/news/70',
	// },
	// 71: {
	// 	stitle: '鉴定资讯',
	// 	root: 3,
	// 	parents: [3],
	// 	parent: 3,
	// 	to: baseDir + 'train/news/71',
	// },
	// 72: {
	// 	stitle: '下载专区',
	// 	root: 3,
	// 	parents: [3],
	// 	parent: 3,
	// 	to: baseDir + 'train/news/72',
	// },
	// 89: {
	// 	stitle: '图片新闻',
	// 	root: 3,
	// 	parents: [3],
	// 	parent: 3,
	// 	to: baseDir + 'train/news/89',
	// },

	5: {
		stitle: '下载专区',
		root: 5,
		parents: [],
		parent: '',
		to: baseDir + 'news/28',
		icon: 'icon-xiazai',
	},
	28: {
		stitle: '文件下载',
		root: 5,
		parents: [5],
		parent: 5,
		to: baseDir + 'news/28',
	},
	6: {
		stitle: '联系我们',
		root: 6,
		parents: [],
		parent: 6,
		to: baseDir + 'news/relative/33',
		icon: 'icon-lianxiwomen',
	},
	33: {
		stitle: '联系我们',
		root: 6,
		parents: [6],
		parent: 6,
		to: baseDir + 'news/relative/33',
	},

	91: {
		stitle: '党建思政',
		root: 91,
		parents: [],
		parent: 91,
		to: baseDir + 'news/99',
		icon: 'icon-dangzhengjiguan',
		//children: [99, 100],
		children: [99],
	},
	99: {
		//stitle: '文件精神',
		stitle: '党建思政',
		root: 91,
		parents: [91],
		parent: 91,
		to: baseDir + 'news/99',
	},
	100: {
		stitle: '党员活动',
		root: 91,
		parents: [91],
		parent: 91,
		to: baseDir + 'news/100',
	},
	106: {
		stitle: '供销行业职业技能等级评价',
		root: 92,
		parents: [92],
		parent: 92,
		to: baseDir + 'news/106',
	},
	93: {
		stitle: '茶艺师',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/93',
	},
	94: {
		stitle: '农产品食品检验员',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/94',
	},
	95: {
		stitle: '汽车维修工',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/95',
	},
	110: {
		stitle: '营养师',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/110',
	},
	111: {
		stitle: '物流服务师',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/111',
	},
	109: {
		stitle: '浙江省职业技能等级认定',
		root: 92,
		parents: [92],
		parent: 92,
		to: baseDir + 'news/93',
	},
	116: {
		stitle: '风险管理师',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/116',
	},
	96: {
		stitle: '农业经理人',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/96',
	},
	112: {
		stitle: '计算机程序设计员',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/112',
	},
	113: {
		stitle: '插花花艺师',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/113',
	},
	114: {
		stitle: '人工智能训练师',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/114',
	},
	115: {
		stitle: '评茶师',
		root: 92,
		parents: [92,109],
		parent: 109,
		to: baseDir + 'news/115',
	},

	104: {
		stitle: '学院简介',
		root: 104,
		parents: [],
		parent: 104,
		to: baseDir + 'news/one/105',
		icon: 'icon-xueyuanjianjie'
	},
	105: {
		stitle: '学院简介',
		root: 104,
		parents: [104],
		parent: 104,
		to: baseDir + 'news/one/105',
	},
}
const links = 66
export default {
	baseDir,
	nav,
	newsType,
	menu,
	links
}
